import { ComponentView, DelegatedObservableArrayChangeListenner, ObservableArray, ViewGenerator, ViewModel } from "binder"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ITemplateSelector } from "../templateSelector";
import { getAsBoolean } from "../utilities";
import { ComboBoxViewModel } from "./comboBox-viewModel"

export class ComboBoxView extends ComponentView<ComboBoxViewModel>{
    GetViewUniqueId(): string {
        return "V-519A7DB0-2EC4-413E-AB34-00A23E2377AA"
    }
    loadHtml(): string {
        let element = require('./comboBox.html').default;
        let style = require('./comboBox.less');
        return element;
    }
    constructor() {
       super();
    }

    private _itemsChangeListenner:any;
    public set items(v: ObservableArray<ViewModel>) { 
        if(this._items){
            this.items.removeChangeListenner(this._itemsChangeListenner);
        }
        this._items = v; 
        this.updateInternalItems();
        if(this._items){
            this._itemsChangeListenner = new DelegatedObservableArrayChangeListenner(this,()=>this.updateSelection());
            this._items.addChangeListenner(this._itemsChangeListenner);
        }
        this.updateSelection();
    } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    
    public set internalItems(v: ObservableArray<ViewModel>) { this._internalItems = v; } public get internalItems(): ObservableArray<ViewModel> { return this._internalItems;} private _internalItems: ObservableArray<ViewModel>;
    private _selectedBuffer:ViewModel;
    
    public set selected(v: ViewModel) { 
        this._selected = v; 
        this.selectedindex = this._combo.selectedIndex+1;
        if(this.selected==null){
            this.selectedindex=-1;
        }else{
            this._selectedBuffer = this.selected;
            this.selectedindex = this.items?.indexOf(this.selected);
        }
    } public get selected(): ViewModel { return this._selected;} private _selected: ViewModel;
    
    public set selectedvalue(v: string) { this._selectedvalue = v; } public get selectedvalue(): string { return this._selectedvalue;} private _selectedvalue: string;
    
    
    public set selectedindex(v: number) { 
        this._selecteindex = v; 
        this.updateSelection();
    } public get selectedindex(): number { return this._selecteindex;} private _selecteindex: number;
    
    private itemTemplate : Node;
    private _combo:HTMLSelectElement;
    
    public set itemtemplateselector(v: ITemplateSelector) { 
        this._itemtemplateselector = v; 
        this.updateInternalItems();
    } public get itemtemplateselector(): ITemplateSelector { return this._itemtemplateselector;} private _itemtemplateselector: ITemplateSelector;
    public set templateselectorfunction(v: string) { 
        this._templateselectorfunction = v; 
        this.updateInternalItems();
    } public get templateselectorfunction(): string { return this._templateselectorfunction;} private _templateselectorfunction: string;
    public set importanthasselectorfunction(v: boolean) { this._importanthasselectorfunction = getAsBoolean(v); } public get importanthasselectorfunction(): boolean { return this._importanthasselectorfunction;} private _importanthasselectorfunction: boolean;
    
    templateSelector(vm:ViewModel){
        let template : any;
        let newNode : Element;
        if(this.itemtemplateselector && this.itemtemplateselector.getTemplate){
            template = this.itemtemplateselector.getTemplate(vm,this.templateselectorfunction);
            if(template){
                newNode = ViewGenerator.CreateFromPrototypeAndViewModel(template,vm);
            }
        }
        if(newNode==null){
            template = this.itemTemplate;
            newNode = ViewGenerator.GetNodeByTemplate(vm,template);
        }
        newNode.setAttribute('value',vm.viewModelObjectId.toString());
        return newNode;
    }
    append(...nodes: (Node | string)[]): void{
        nodes.forEach(node=>{
            if(node instanceof HTMLElement && node.classList.contains("template")){
                this.itemTemplate = super.removeAsTemplate(node);
            }else{
                this._combo.append(node);
            }
        })
    }
    onchange(e){
        try{
            let selectObject:HTMLSelectElement = <HTMLSelectElement>this._combo;
            this.selectedvalue = selectObject.value;
            let viewModelObjectId = parseInt(selectObject.value)
            if(isNaN(viewModelObjectId))
                this.selected = null;
            else{
                this.selected = this.items.filter(x=>x.viewModelObjectId==viewModelObjectId)[0];
            }
        }catch{
            this.selected = null;
        }
        this.updateSelection();
    }
    onRenderCompleted(){
        this._combo = <HTMLSelectElement>this.firstlevelElement.querySelector('select');
        this.updateSelection();
    }

    updateSelection(){
        if(this._combo){
            let newIndex = this.selectedindex+1;
            this._combo.selectedIndex = newIndex; 
        }
    }

    updateInternalItems(){
        if((this.importanthasselectorfunction??false)==false){
            this.internalItems = this.items;
            this.selected = this._selectedBuffer;
        }else{
            if(this.itemtemplateselector!=null && stringIsNullOrEmpty(this.templateselectorfunction)==false){
                this.internalItems = this.items;
                this.selected = this._selectedBuffer;
            }
        }
    }
}
